import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { TripOverviewPage } from './trips/TripOverviewPage';
import { ActiveTripsPage } from './trips/ActiveTripsPage';
import { TripHistoryPage } from './trips/TripHistoryPage';
import { CreateTripPage } from './trips/CreateTripPage';
// Removed: TripAnalyticsPage - moved to Global Reports for superadmin
// Removed: TripRatingsPage - moved to separate Ratings & Reviews module

export function TripsPage() {
  return (
    <Layout>
      <Routes>
        <Route index element={<TripOverviewPage />} />
        <Route path="active" element={<ActiveTripsPage />} />
        <Route path="history" element={<TripHistoryPage />} />
        <Route path="create" element={<CreateTripPage />} />
    
        <Route path="*" element={<Navigate to="/trips" replace />} />
      </Routes>
    </Layout>
  );
}
